export class OperatorIn {
    id: string = ""
    name: string = ""
    imageUrl: string = ""

    static fromWire(input: any): OperatorIn {
        return Object.assign(new OperatorIn, {id: input.id, name:input.name, imageUrl: input.image_url})
    }
}